import { Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import BKGlobalLayout from 'components/bank/AGBBank/GlobalLayout';
import { useLanguage } from 'hooks/Language/useLanguage';
import urls from 'routes/urls';
import {
  openKycPrompt,
  useKycProgress,
} from 'utils/kycProgressStore';
import './index.scss';

/**
 * Shown instead of an account-dependent page (opened by URL or a stale
 * link) while the user's bank account is still being opened.
 */
const AccountLockedPage: React.FC = () => {
  const { translate } = useLanguage();
  const navigate = useNavigate();
  const kyc = useKycProgress();
  const docsMissing = kyc.known && !kyc.isComplete;

  return (
    <BKGlobalLayout>
      <section className="acc-locked">
        <span className="acc-locked__icon">
          <LockOutlined />
        </span>
        <h2>{translate('Available once your account is opened')}</h2>
        <p>
          {translate(
            'This part of G-Banking needs an open AGB account. It unlocks automatically as soon as AGB opens yours.',
          )}
        </p>
        <div className="acc-locked__actions">
          <Button
            size="large"
            onClick={() => navigate(urls.dashboard)}
          >
            {translate('See my application')}
          </Button>
          {docsMissing && (
            <Button
              type="primary"
              size="large"
              className="acc-open__cta"
              onClick={openKycPrompt}
            >
              {translate('Continue verification')}
            </Button>
          )}
        </div>
      </section>
    </BKGlobalLayout>
  );
};

export default AccountLockedPage;
